module.exports = __webpack_public_path__ + "img/marketing.fa5e3567.png";